import { brandHintFromUrl } from './brandHintFromUrl';

type Analytics = {
  group: (key: string, value: string) => void;
};

type Logger = {
  info: (message: string, context?: Record<string, unknown>) => void;
};

type SyncBrandDeps = {
  url: URL;
  hostname: string;
  currentHubLabel: string | null;
  hubHasIdentity?: boolean;
  onHubLabelChanged: (hubLabel: string) => void;
  analytics?: Analytics | null;
  logger: Logger;
};

// gloss
export const syncBrandFromUrl = ({
  url,
  hostname,
  currentHubLabel,
  hubHasIdentity = false,
  onHubLabelChanged,
  analytics,
  logger,
}: SyncBrandDeps): string | null => {
  const nextHubLabel = brandHintFromUrl({ url, hostname });
  if (!nextHubLabel) return null;

  if (currentHubLabel === nextHubLabel) return null;

  if (!hubHasIdentity) onHubLabelChanged(nextHubLabel);

  if (analytics) {
    try {
      analytics.group('company', nextHubLabel);
    } catch (err) {
      logger.info('Analytics group tagging failed; continuing', {
        brand: nextHubLabel,
        error: err instanceof Error ? err.message : String(err),
      });
    }
  }

  return nextHubLabel;
};
